import React from 'react';

import { FormikInput } from 'components/UiKit/FormikFields';
import FormField from 'screens/Equipment/components/FormField';
import NameField from '../NameField';
import CurrentStatusField from '../CurrentStatusField';
import EquipmentTypeField from '../EquipmentTypeField';

const EquipmentDetailsSection = () => (
  <div className="block" data-testid="equipment-item-details-section">
    <div className="text-2xl font-bold">Basic Info</div>
    <div className="flex w-full">
      <div className="w-full mr-16">
        <NameField />
      </div>
      <div className="w-full">
        <EquipmentTypeField />
      </div>
    </div>
    <div className="flex w-full">
      <div className="flex w-1/2 mr-16">
        <div className="w-1/2 mr-8">
          <FormField label="Year" htmlFor="modelYear">
            <FormikInput id="modelYear" name="modelYear" />
          </FormField>
        </div>
        <div className="w-1/2">
          <FormField label="Make" htmlFor="make">
            <FormikInput id="make" name="make" />
          </FormField>
        </div>
      </div>
      <div className="w-1/2">
        <FormField label="Model" htmlFor="model">
          <FormikInput id="model" name="model" />
        </FormField>
      </div>
    </div>
    <div className="flex w-full">
      <div className="w-1/2 mr-16">
        <CurrentStatusField />
      </div>
      <div className="w-1/2">
        <FormField label="Unit ID" htmlFor="unitID">
          <FormikInput id="unitID" name="unitID" />
        </FormField>
      </div>
    </div>
    <div className="flex">
      <div className="block w-1/2 mr-16">
        <FormField label="Serial Number" htmlFor="serialNumber">
          <FormikInput id="serialNumber" name="serialNumber" />
        </FormField>
      </div>
      <div className="block w-1/2">
        <FormField label="License Number" htmlFor="licenseNumber">
          <FormikInput id="licenseNumber" name="licenseNumber" />
        </FormField>
      </div>
    </div>
  </div>
);

export default EquipmentDetailsSection;
